import { Component, inject, OnInit } from '@angular/core'
import { PermissionsService } from '@account/Services/PermissionsService'
import {
	ActivatedRoute,
	Event,
	NavigationEnd,
	ParamMap,
	Router,
	RouterOutlet,
} from '@angular/router'
import { switchMap } from 'rxjs/operators'
import { MatSnackBar } from '@angular/material/snack-bar'
import { SystemConfigService } from '@account/Services/SystemConfigService'
import { Angulartics2GoogleAnalytics } from 'angulartics2'
import { NavComponent } from '@account/Components/Nav/Nav.Component'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'my-app',
	templateUrl: './App.Component.html',
	imports: [NavComponent, RouterOutlet, NgStyle],
})
export class AppComponent implements OnInit {
	public isHomepage = false

	public year: number

	public permissionsService: PermissionsService

	public systemConfigService: SystemConfigService

	private readonly activatedRoute: ActivatedRoute

	private readonly matSnackBar: MatSnackBar

	constructor() {
		this.permissionsService = inject(PermissionsService)
		this.systemConfigService = inject(SystemConfigService)
		this.activatedRoute = inject(ActivatedRoute)
		this.matSnackBar = inject(MatSnackBar)

		const router = inject(Router)
		const angulartics2GoogleAnalytics = inject(Angulartics2GoogleAnalytics)

		router.events.subscribe((event: Event) => {
			if (event instanceof NavigationEnd) {
				this.isHomepage = event.url === '/'
			}
		})

		this.year = new Date().getFullYear()

		if (this.systemConfigService.config.analytics) {
			if (this.permissionsService.account) {
				angulartics2GoogleAnalytics.setUsername(
					this.permissionsService.account.email,
				)
			}

			angulartics2GoogleAnalytics.startTracking()
		}
	}

	public ngOnInit() {
		this.activatedRoute.queryParamMap
			.pipe(
				switchMap(async (params: ParamMap) => {
					return Boolean(params.get('email-confirmed'))
				}),
			)
			.subscribe((emailConfirmed: boolean) => {
				if (emailConfirmed) {
					this.isHomepage = true
					this.matSnackBar.open('Email address successfully confirmed', 'Okay')
				}
			})
	}
}
